"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("classnames");
var react_transition_group_1 = require("react-transition-group");
var menu_1 = require("../menu");
var surface_1 = require("../surface");
var icon_1 = require("../icon");
var badge_1 = require("../badge");
var MainMenu = /** @class */ (function (_super) {
    tslib_1.__extends(MainMenu, _super);
    function MainMenu(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.open = function () {
            var _a = _this.state, isOpen = _a.isOpen, isOpenFromClick = _a.isOpenFromClick;
            if (!isOpen) {
                _this.setState({ isOpen: true, isOpenFromClick: isOpenFromClick });
            }
        };
        _this.toggleOpenInClick = function (e) {
            var _a = _this.state, isOpenFromClick = _a.isOpenFromClick, isOpen = _a.isOpen;
            var _b = _this.props, onClick = _b.onClick, allowOpenInClick = _b.allowOpenInClick;
            onClick && onClick(e);
            if (allowOpenInClick) {
                _this.setState({ isOpenFromClick: !isOpenFromClick, isOpen: isOpen });
            }
        };
        _this.close = function () {
            var _a = _this.state, isOpen = _a.isOpen, isOpenFromClick = _a.isOpenFromClick;
            if (isOpen && !isOpenFromClick) {
                _this.setState({ isOpen: false, isOpenFromClick: isOpenFromClick });
            }
        };
        _this.onMenuItemClick = function (e) {
            var onItemClick = _this.props.onItemClick;
            _this.close();
            onItemClick && onItemClick(e);
        };
        _this.stopMouseOver = function (e) {
            e.stopPropagation();
            e.preventDefault();
        };
        _this.state = { isOpen: false, isOpenFromClick: false };
        return _this;
    }
    MainMenu.prototype.getSurfaceTransitionClasses = function () {
        var theme = this.props.theme;
        return {
            enter: theme.surfaceEnter,
            enterActive: theme.surfaceEnterActive,
            exit: theme.surfaceLeave,
            exitActive: theme.surfaceLeaveActive
        };
    };
    MainMenu.prototype.renderMenu = function () {
        var _a;
        var _b = this.props, children = _b.children, theme = _b.theme, surfaceLevel = _b.surfaceLevel, stickTo = _b.stickTo, numberstick = _b.numberstick;
        var styles = (_a = {},
            _a[stickTo] = numberstick,
            _a);
        return (React.createElement(surface_1.Surface, { level: surfaceLevel, className: theme.surface, style: styles },
            React.createElement(menu_1.Menu, { surfaceLevel: 0, onItemClick: this.onMenuItemClick }, children)));
    };
    MainMenu.prototype.render = function () {
        var _a, _b, _c;
        var _d = this.props, theme = _d.theme, allowOpenInClick = _d.allowOpenInClick, className = _d.className, iconName = _d.iconName, label = _d.label, userIconSize = _d.iconSize, onItemClick = _d.onItemClick, surfaceLevel = _d.surfaceLevel, active = _d.active, link = _d.link, stickTo = _d.stickTo, badgeColor = _d.badgeColor, badgeLabel = _d.badgeLabel, badgeLabelBottom = _d.badgeLabelBottom, showBadgeLabelBottom = _d.showBadgeLabelBottom, others = tslib_1.__rest(_d, ["theme", "allowOpenInClick", "className", "iconName", "label", "iconSize", "onItemClick", "surfaceLevel", "active", "link", "stickTo", "badgeColor", "badgeLabel", "badgeLabelBottom", "showBadgeLabelBottom"]);
        var isOpen = this.state.isOpen;
        var iconOnly = !label;
        var classes = classnames_1.default(theme["main-menu"], className, (_a = {},
            _a[theme.link] = link && this.context.linkComponent,
            _a[theme.open] = isOpen,
            _a[theme.active] = active,
            _a[theme["no-label"]] = iconOnly,
            _a));
        var iconSize = userIconSize;
        if (isNaN(userIconSize)) {
            iconSize = iconOnly ? 2.2 : 2;
        }
        var badgeProps = {};
        if (badgeColor) {
            badgeProps[badgeColor] = true;
        }
        var content = (React.createElement(React.Fragment, null,
            iconName ? (React.createElement("div", { className: theme.icon },
                badgeLabel ? React.createElement(badge_1.default, tslib_1.__assign({ className: theme.badge }, badgeProps), badgeLabel) : null,
                badgeLabelBottom ? (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: classnames_1.default(theme.badgeBottomSign, (_b = {}, _b[theme.showBadgeLabelBottom] = showBadgeLabelBottom, _b)) }),
                    React.createElement(badge_1.default, tslib_1.__assign({ style: { pointerEvents: "none" }, className: classnames_1.default(theme.badgeBottom, (_c = {}, _c[theme.showBadgeLabelBottom] = showBadgeLabelBottom, _c)) }, badgeProps), badgeLabelBottom))) : null,
                React.createElement(icon_1.default, { iconName: iconName, size: iconSize }))) : null,
            label ? React.createElement("div", { className: theme.label }, label) : null));
        if (link && this.context.linkComponent) {
            var LinkComponent = this.context.linkComponent;
            content = React.createElement(LinkComponent, tslib_1.__assign({}, link), content);
        }
        return (React.createElement("div", tslib_1.__assign({}, others, { className: classes, onMouseEnter: this.open, onMouseLeave: this.close, onClick: this.toggleOpenInClick }),
            content,
            React.createElement(react_transition_group_1.CSSTransition, { in: isOpen, unmountOnExit: true, classNames: this.getSurfaceTransitionClasses(), timeout: 200 }, this.renderMenu())));
    };
    MainMenu.defaultProps = {
        surfaceLevel: 2,
        active: false,
        stickTo: "left",
        allowOpenInClick: false,
        numberstick: 0,
        showBadgeLabelBottom: true
    };
    MainMenu.contextTypes = {
        linkComponent: PropTypes.any
    };
    return MainMenu;
}(React.Component));
exports.default = MainMenu;
